import { supabase } from '../../shared/supabase/supabaseClient';
import type { ComplaintStats, ComplaintReason } from '../domain/complaintTypes';
import { emptyReasonStats } from '../domain/complaintTypes';

export async function fetchComplaintStats(
  orgId: string,
  from: string,
  to: string,
): Promise<ComplaintStats> {
  const { data, error } = await supabase
    .from('customer_complaints')
    .select('status, reason')
    .eq('organization_id', orgId)
    .gte('created_at', from)
    .lte('created_at', to);

  if (error) throw new Error(error.message);

  const rows = data ?? [];
  const stats: ComplaintStats = {
    total: rows.length,
    resolved: rows.filter((r) => r.status === 'resolved').length,
    escalated: rows.filter((r) => r.status === 'escalated').length,
    byReason: emptyReasonStats(),
  };

  for (const row of rows) {
    const reason = row.reason as ComplaintReason;
    if (reason in stats.byReason) {
      stats.byReason[reason]++;
    }
  }

  return stats;
}
